/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Pain_Points_TitleInputs */

const en_meta_pain_points_title = /** @type {(inputs: Meta_Pain_Points_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business processes AI can automate: six examples | Lindevo`)
};

const lv_meta_pain_points_title = /** @type {(inputs: Meta_Pain_Points_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzņēmuma procesu automatizācija ar AI: seši piemēri | Lindevo`)
};

/**
* | output |
* | --- |
* | "Business processes AI can automate: six examples \| Lindevo" |
*
* @param {Meta_Pain_Points_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_pain_points_title = /** @type {((inputs?: Meta_Pain_Points_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Pain_Points_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_pain_points_title(inputs)
	return en_meta_pain_points_title(inputs)
});